var _path, _linearGradient;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.225 12.9999L11.7287 17.6462L16.9468 10.9999H11.7747L12.2703 6.36605L7.06264 12.9999L12.225 12.9999ZM14.6295 3.11426C14.7363 2.11547 13.4688 1.60032 12.8485 2.39043L4.21973 13.3824C3.70461 14.0386 4.17209 14.9999 5.00631 14.9999L9.99999 14.9999L9.36999 20.897C9.26329 21.8957 10.5306 22.4108 11.1509 21.6208L19.7898 10.6175C20.305 9.96128 19.8376 8.99993 19.0033 8.99993L14 8.99993L14.6295 3.11426Z",
    fill: "url(#paint0_linear)"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 23.4291,
    y1: 26.625,
    x2: 9.68946,
    y2: -1.1527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0965F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31D8BF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.946a0027f19979837d675f47b958d615.svg";
export { ForwardRef as ReactComponent };